module.exports = __webpack_public_path__ + "media/mypage/images/close-button-bf80759b0091a70f13284cb1d7d63700.png";